import _ from 'lodash';

const orderFromLocalStorage = (state, payload) => {
  const newState = _.cloneDeep(state);
  newState.orders.active = payload.active || {};
  return newState;
};

export { orderFromLocalStorage };
